// @flow
import { type Node } from 'react';

import toFixedValue from 'app/common/lib/toFixedValue';


type Props = {
  number: ?number,
}

const CellNumber = ({ number }: Props): Node => {
  if (number === undefined || number === null || Number.isNaN(number)) {
    return '—';
  }

  return (
    toFixedValue(number)
  );
};

export default CellNumber;
